<div fxLayout="row wrap" fxLayoutAlign="center center" style="height: 70vh">
  <dx-load-indicator height="60" width="60"></dx-load-indicator>
</div>
